import { GET_SHELVE_GOODS } from "constants/shelveGoods";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SHELVE_GOODS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
